import React, { useState, useEffect } from 'react'
import TaskCode from '../../Shared/TaskCode'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

import { unitTasksService } from '../../../_services/unitTasks.service'
import { toastr } from 'react-redux-toastr'
import LoadingDots from '../../Shared/LoadingDots'

// Import React Table
import ReactTable from 'react-table'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ReservedTaskModal = props => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [data, setData] = useState(undefined)

  useEffect(() => {
    if (props.taskCode) {
      setOpen(true)
      setLoading(true)
      getData(props.taskCode)
    } else {
      setLoading(false)
      setOpen(false)
    }
  }, [props.taskCode])

  const getData = productId => {
    unitTasksService
      .getReservedTasksByProductId(productId)
      .then(res => {
        console.log(res.data)
        setData(res.data)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        toastr.warning('مشکلی پیش آمد')
        setLoading(false)
      })
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      fullWidth={true}
      maxWidth="xl"
      onClose={() => props.onClose()}>
      <DialogTitle>
        <Fab
          color="secondary"
          aria-label="refresh"
          size="small"
          onClick={() => props.onClose()}
          className="modal-close-btn">
          <MdClose size="20px" />
        </Fab>
      </DialogTitle>
      <DialogContent className="relative" style={{ minHeight: 150 }}>
        {loading ? (
          <LoadingDots loading={loading} />
        ) : data ? (
          <div className="table-container" style={{ marginTop: 0 }}>
            <table className="table">
              <thead>
                <tr>
                  <th className="text-center">ردیف</th>
                  <th className="text-center">کد رزرو</th>
                  <th className="text-center">برند</th>
                  <th className="text-center">نام کالا</th>
                  <th className="text-center">مواد اولیه رزرو شده</th>
                  <th className="text-center">توضیحات</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.length > 0 &&
                  data.map((taskItem, taskIndex) => (
                    <tr key={`task-${taskIndex}`}>
                      <td>{taskIndex + 1}</td>
                      <td>
                        <TaskCode code={taskItem.taskCode} reserve={true} />
                      </td>
                      <td>
                        {taskItem.product &&
                          taskItem.product.brand &&
                          taskItem.product.brand.name}
                      </td>
                      <td>
                        {taskItem.product &&
                          taskItem.product.category &&
                          taskItem.product.category.name +
                            ' (' +
                            taskItem.product.name +
                            ')'}
                      </td>
                      <td>
                        {taskItem.taskOperationProducts &&
                        taskItem.taskOperationProducts.length > 0 ? (
                          <table className="table table-bordered m-0">
                            <thead>
                              <tr>
                                <th className="text-center">
                                  نام کالای رزرو شده
                                </th>
                                <th className="text-center">میزان رزرو</th>
                              </tr>
                            </thead>
                            <tbody>
                              {taskItem.taskOperationProducts.map(
                                (rItem, rIndex) => (
                                  <tr key={rItem.id + '-' + rIndex}>
                                    <td>
                                      {taskItem.product &&
                                        rItem.product.category && (
                                          <div className="flex flex-col">
                                            <strong>
                                              {rItem.product.category.name}
                                            </strong>
                                            <strong
                                              style={{ padding: '4px 0' }}>
                                              {rItem.product.brand.name}
                                            </strong>
                                            <strong
                                              style={{
                                                backgroundColor: 'yellow'
                                              }}>
                                              {' (' + rItem.product.name + ')'}
                                            </strong>
                                          </div>
                                        )}
                                    </td>
                                    <td>
                                      {rItem.product !== undefined && (
                                        <div className="flex-col flex-center">
                                          <MeasurementTypeDoubleBox
                                            product={rItem.product}
                                            value={rItem.quantity}
                                            onlySub={
                                              rItem.subquantity !== undefined &&
                                              rItem.quantity !==
                                                rItem.subQuantity
                                                ? true
                                                : false
                                            }
                                          />
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        ) : (
                          ''
                        )}
                      </td>
                      <td>
                        {taskItem.unitTask && taskItem.unitTask.description}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {/* <ReactTable
              manual
              data={data}
              loading={loading}
              showPagination={false}
              minRows={0}
              columns={[
                {
                  Header: 'ردیف',
                  id: 'createdAt',
                  maxWidth: 50,
                  filterable: false,
                  sortable: false,
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  className: 'numberFa',
                  Cell: row => {
                    return row.index + 1
                  }
                },
                {
                  Header: 'کد رزرو',
                  accessor: 'taskCode',
                  id: 'taskCode',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'visible',
                    justifyContent: 'center'
                  },
                  Cell: row => {
                    return (
                      <TaskCode code={row.original.taskCode} reserve={true} />
                    )
                  }
                },
                {
                  Header: 'برند',
                  accessor: 'brand',
                  id: 'brandId',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'visible',
                    justifyContent: 'center'
                  },
                  sortable: false,
                  Cell: row =>
                    row.original.product &&
                    row.original.product.brand &&
                    row.original.product.brand.name
                },
                {
                  Header: 'نام کالا',
                  accessor: 'product.name',
                  id: 'name',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'visible',
                    justifyContent: 'center'
                  },
                  sortable: false,
                  Cell: row => {
                    return (
                      row.original.product &&
                      row.original.product.category &&
                      row.original.product.category.name +
                        ' (' +
                        row.original.product.name +
                        ')'
                    )
                  }
                },
                {
                  Header: 'مواد اولیه رزرو شده',
                  accessor: 'product.category.name',
                  id: 'categoryId',
                  style: {
                    display: 'block',
                    alignItems: 'center',
                    overflow: 'visible',
                    justifyContent: 'center',
                    minWidth: 350
                  },
                  width: 350,
                  sortable: false,
                  Cell: row =>
                    row.original.taskOperationProducts &&
                    row.original.taskOperationProducts.length > 0 ? (
                      <table className="table table-bordered m-0">
                        <thead>
                          <tr>
                            <th className="text-center">نام کالای رزرو شده</th>
                            <th className="text-center">میزان رزرو</th>
                          </tr>
                        </thead>
                        <tbody>
                          {row.original.taskOperationProducts.map(
                            (rItem, rIndex) => (
                              <tr key={rItem.id + '-' + rIndex}>
                                <td>
                                  {row.original.product &&
                                    rItem.product.category && (
                                      <div className="flex flex-col">
                                        <strong>
                                          {rItem.product.category.name}
                                        </strong>
                                        <strong style={{ padding: '4px 0' }}>
                                          {rItem.product.brand.name}
                                        </strong>
                                        <strong
                                          style={{ backgroundColor: 'yellow' }}>
                                          {' (' + rItem.product.name + ')'}
                                        </strong>
                                      </div>
                                    )}
                                </td>
                                <td>
                                  {rItem.product !== undefined && (
                                    <div className="flex-col flex-center">
                                      <MeasurementTypeDoubleBox
                                        product={rItem.product}
                                        value={rItem.quantity}
                                        onlySub={
                                          rItem.subquantity !== undefined &&
                                          rItem.quantity !== rItem.subQuantity
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    ) : (
                      ''
                    )
                },
                {
                  Header: 'توضیحات',
                  accessor: 'description',
                  id: 'description',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'visible',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    whiteSpace: 'initital'
                  },
                  sortable: false,
                  Cell: row =>
                    row.original.unitTask && row.original.unitTask.description
                }
              ]}
              className="-striped -highlight"
            /> */}
          </div>
        ) : (
          ''
        )}
      </DialogContent>
    </Dialog>
  )
}
export default ReservedTaskModal
